import { useEffect, useState } from "react";
import CustomButton from "../../../../../components/custom/button";
import CustomInput from "../../../../../components/custom/input";
import {
  getProfileDataAsync,
  updateProfileDataAsync,
} from "../../../../../../app/slices/profileSlice/ProfileSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import SaveAsIcon from "@mui/icons-material/SaveAs";
interface Errors {
  email?: string;
}
export const ChangeEmail = ({
  modalClose,
  emailProp,
  fromCheckout,
  setProfileData,
}: {
  modalClose: () => void;
  emailProp: any;
  fromCheckout?: boolean;
  setProfileData?: any;
}) => {
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState<string>(emailProp);
  const [errors, setErrors] = useState<Errors>({});
  const { updateLoader } = useAppSelector((state) => state.ProfileState);
  useEffect(() => {
    setEmail(emailProp);
  }, [emailProp]);
  const emailValidation = (values: any) => {
    let errors: any = {};

    const value = values?.trim() || "";
    if (!value) {
      errors.email = "Please Enter email.";
    } else if (value) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(value)) {
        errors.email = `Please enter a valid Email.`;
      }
    }

    return errors;
  };
  const emailUpdateAsync = () => {
    const errorCheck = emailValidation(email);
    if (Object.keys(errorCheck).length === 0) {
      dispatch(updateProfileDataAsync({ email: email }))
        .then((response: any) => {
          if (response?.payload?.status === 200) {
            dispatch(
              showSnackbar({
                message: "Email is updated succesfuly.",
                severity: "success",
                autoHide: 2000,
              })
            );
            if (fromCheckout) {
              setProfileData((prevData: any) => ({
                ...prevData,
                email: email,
              }));
            } else {
              dispatch(getProfileDataAsync());
            }
            modalClose();
          } else if (response?.payload?.status === 400) {
            let message = response?.payload?.data?.errors?.email[0];
            dispatch(
              showSnackbar({
                message: message
                  ? message
                  : "Email  updation failed, please try again.",
                severity: "error",
                autoHide: 3000,
              })
            );
          } else {
            dispatch(
              showSnackbar({
                message: "Please try again later.",
                severity: "error",
                autoHide: 3000,
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            showSnackbar({
              message: "Please try again later.",
              severity: "error",
              autoHide: 3000,
            })
          );
        });
    } else {
      setErrors(errorCheck);
    }
  };
  const inputChange = (e: any) => {
    setEmail(e.target.value);
    const errorCheck = emailValidation(e.target.value);

    setErrors(errorCheck);
  };
  return (
    <div className="canvas-body p-0">
      <div className="tf-search-content">
        <div className="tf-field style-1 mb_15 mt-5">
          <CustomInput
            type="email"
            label="Email"
            required
            name="email"
            size="small"
            value={email}
            onChange={inputChange}
            variant="outlined"
            error={!!errors?.email}
            fullWidth
            helperText={errors?.email}
            // focused
            //   loader={profileDataState?.loader}
            //   endIcon={
            //     email_verified ? (
            //       <CheckCircleOutline color="success" />
            //     ) : (
            //       <Tooltip title="Please verify your email.">
            //         <InfoIcon color="info" />
            //       </Tooltip>
            //     )
            //   }
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <CheckIcon />
            //     </InputAdornment>
            //   ),
            // }}
          />
        </div>
        <CustomButton
          size="medium"
          //   fullWidth
          onClick={emailUpdateAsync}
          name="Save"
          className="mb-3"
          endIcon={<SaveAsIcon />}
          loader={updateLoader}
        />
        {/* {Object.keys(errors).length === 0 && (
          <div>
            <h5 className="email-verify">Verified over the email !</h5>
            <p>
              A verification email has sent to your email <i>{email}</i>
            </p>
          </div>
        )} */}
      </div>
    </div>
  );
};
